import React from "react";
import styles from "../CareerSupport/CareerSupport.module.scss";
import vacationalTraining from "../../../assets/images/vacationalTraining.jpg";
import trainedGlobally from "../../../assets/images/trainedGlobally.png";
import citiesWorld from "../../../assets/images/citiesWorld.jpg";
import institutes from "../../../assets/images/institutes.png";
import alignedProgram from "../../../assets/images/alignedProgram.jpg";
import successStories from "../../../assets/images/successStories.jpg";
import successfullBusiness from "../../../assets/images/successfullBusiness.jpg";
import AwardWinning from "../../../assets/images/AwardWinning.png";

const cardData = [
  {
    img: "/images/brainstorming-training-board.jpg",
    alt: "Woman Writing On Chalkboard In Team Meeting",
    text: "40+ years of expertise in vocational training",
    title: "Creative Planning Session",
  },
  {
    img: "/images/aptech-global-training-network.png",
    alt: "Graphic of Modern Training Institution Buildings",
    text: "7.5 million students trained globally",
    title: "Youth Team Promoting Global Training Program",
  },
  {
    img: "/images/aptech-cities-worldwide.jpg",
    alt: "Glass Exterior of Business Tower",
    text: "Present in 200+ cities worldwide",
    title: "Modern Office Building",
  },
  {
    img: "/images/aptech-training-institutes.png",
    alt: "Modern Training Institutional Buildings Graphic",
    text: "Partnerships with governments, enterprises, and institutes",
    title: "Modern Training Institute",
  },
  {
    img: alignedProgram,
    alt: "alignedProgram",
    text: "Globally recognized Industry-aligned programs",
    title: "",
  },
  {
    img: successStories,
    alt: "successStories",
    text: "Proven track record of success stories",
    title: "",
  },
  {
    img: successfullBusiness,
    alt: "successfullBusiness",
    text: "A successful Business Partnership Model",
    title: "",
  },
  {
    img: AwardWinning,
    alt: "AwardWinning",
    text: "Award winning brand for excellence in skill-based education",
    title: "",
  },
];

const CareerSupport: React.FC = () => {
  return (
    <div className="section">
      <div id="CareerSupport" className={styles.careerSupport}>
        <CareerListView />
      </div>
    </div>
  );
};

const CareerListView = () => {
  // const chunkArray = (arr: any[], size: number) => {
  //   return Array.from({ length: Math.ceil(arr.length / size) }, (_, i) =>
  //     arr.slice(i * size, i * size + size)
  //   );
  // };

  // const cardChunks = chunkArray(cardData, 3);
  return (
    <div className="">
      <div className="row g-0">
        <div className="col-12">
          <div className="container">
            <p className="heading text-center">The Aptech Advantage</p>
          </div>

          <div className={styles.contentDiv}>
            <div className="container">
              <div className={`${styles.contentDiv} row g-0`}>
                <div
                  className={`col-lg-12 col-md-12 col-sm-12 d-flex flex-column justify-content-center`}
                >
                  <p className={`para ${styles.paragraphContent} text-center`}>
                    With a strong{" "}
                    <strong>
                      legacy, global presence, and industry-aligned programs,
                    </strong>{" "}
                    Aptech continues to shape the future of education and
                    workforce development.
                  </p>
                </div>
              </div>
              <div className="row justify-content-center">
                {cardData.map((item, index) => (
                  <div
                    className="col-lg-4 col-md-6 col-sm-6 col-12 mt-4"
                    key={index}
                  >
                    <div className={styles.carrerCard}>
                      <img src={item.img} alt={item.alt} />
                      <p className="para2 mb-0">{item.text}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default CareerSupport;
